import { render } from "./ward_master.vue?vue&type=template&id=7c9f2f09&scoped=true"
import script from "./ward_master.vue?vue&type=script&lang=js"
export * from "./ward_master.vue?vue&type=script&lang=js"

import "./ward_master.vue?vue&type=style&index=0&id=7c9f2f09&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9f2f09"]])

export default __exports__